// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    <terceraLabel text="{{label}}" />

    <div class="oe-selector-right">
        <div class="quotePricePicker">
            <terceraButton name="modifyPrice"
                           terceraButtonStyle="js-ordModify-btn-copyto"
                           SVG="true"
                           on-btnClick="click"
                           enabled="{{price !== null}}" />

            <terceraLabel text="{{fPrice}}" additionalClass="{{side === 0 ? 'sell-color' : 'buy-color'}}" />
        </div>
    </div>
</div>`;
// Exports
export default code;